import { render, staticRenderFns } from "./wizard.vue?vue&type=template&id=7e895da1&scoped=true&lang=pug"
import script from "./wizard.vue?vue&type=script&lang=ts"
export * from "./wizard.vue?vue&type=script&lang=ts"
import style0 from "./wizard.vue?vue&type=style&index=0&id=7e895da1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e895da1",
  null
  
)

export default component.exports